export const STORAGE_KEY_BORDERFREE_GOOGLE_ADS_PARAMETERS = 'GlobalE_Analytics_GoogleAds';

export const BFGCLID = 'bfgclid';

export type BorderfreeGoogleAdsHandlerSettings = {
  bfGoogleAdsEnabled: boolean;
  bfGoogleAdsLifetimeInDays: number;
}

export type BorderfreeGoogleAdsPreset = string | BorderfreeGoogleAds;

export type BorderfreeGoogleAds = {
  bfgclid: string;
};
